var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.519,
    height: 35.511,
    viewBox: "0 0 35.519 35.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M17.758,10.889a9.1,9.1,0,1,0,9.1,9.1A9.09,9.09,0,0,0,17.758,10.889Zm0,15.024a5.919,5.919,0,1,1,5.919-5.919A5.93,5.93,0,0,1,17.758,25.912Zm11.6-15.4a2.124,2.124,0,1,1-2.124-2.124A2.119,2.119,0,0,1,29.358,10.516Zm6.03,2.155c-.135-2.845-.784-5.364-2.868-7.44s-4.6-2.726-7.44-2.868c-2.932-.166-11.719-.166-14.651,0-2.837.135-5.357.784-7.44,2.86S.262,9.819.12,12.663C-.047,15.6-.047,24.383.12,27.315c.135,2.845.784,5.364,2.868,7.44s4.6,2.726,7.44,2.868c2.932.166,11.719.166,14.651,0,2.845-.135,5.364-.784,7.44-2.868s2.726-4.6,2.868-7.44c.166-2.932.166-11.711,0-14.643ZM31.6,30.46a5.993,5.993,0,0,1-3.376,3.376c-2.338.927-7.884.713-10.467.713s-8.138.206-10.467-.713A5.993,5.993,0,0,1,3.915,30.46C2.988,28.123,3.2,22.576,3.2,19.993S3,11.855,3.915,9.526A5.993,5.993,0,0,1,7.291,6.15c2.338-.927,7.884-.713,10.467-.713s8.138-.206,10.467.713A5.993,5.993,0,0,1,31.6,9.526c.927,2.338.713,7.884.713,10.467S32.528,28.131,31.6,30.46Z",
    transform: "translate(0.005 -2.238)",
    fill: "#74ad85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.9ddc2661.svg";
export { ForwardRef as ReactComponent };